import { Box, Heading } from "@vinomofo/components";

import { COLORS } from "../../../styles";
import styled from "styled-components";

const SectionHeaderWrapper = styled(Box)`
  * + * {
    margin-top: 12px;
  }
`;

export interface SectionHeaderProps {
  heading?: string;
  subheading?: string;
  align?: "left" | "center" | "right";
  type?: "regular" | "large";
}

export const SectionHeader = ({
  heading,
  subheading,
  align = "center",
  type,
}: SectionHeaderProps): JSX.Element => {
  let renderView = (
    <SectionHeaderWrapper width="100%" textAlign={align} py={4}>
      {subheading && (
        <Heading variant="xxs" as="p" fontWeight="500" color="brand">
          {subheading}
        </Heading>
      )}
      {heading && (
        <Heading variant="md" as="h3">
          {heading}
        </Heading>
      )}
    </SectionHeaderWrapper>
  );
  if (type === "large")
    renderView = (
      <SectionHeaderWrapper width="100%" textAlign={align} py={4} mb={20}>
        {subheading && (
          <Box
            borderBottom="2px solid"
            borderBottomColor="mofoGreen"
            width="fit-content"
            margin="0 auto"
          >
            <Heading
              variant="xxl"
              fontSize={84}
              as="p"
              fontWeight="600"
              color="black"
            >
              {subheading}
            </Heading>
          </Box>
        )}
        {heading && (
          <Heading variant="sm" as="p" fontSize={20} fontStyle={"italic"}>
            {heading}
          </Heading>
        )}
      </SectionHeaderWrapper>
    );

  return renderView;
};
